module.exports = __webpack_public_path__ + "img/ribbon.247a564b.svg";